export type ChoirScheduleGuideStepId = "set_service_days" | "create_schedule";

export interface ChoirScheduleGuideState {
    completed: ChoirScheduleGuideStepId[];
    dismissed_at: string | null;
    completed_at: string | null;
}

export const CHOIR_SCHEDULE_GUIDE_STEPS: ChoirScheduleGuideStepId[] = [
    "set_service_days",
    "create_schedule",
];

export function createDefaultChoirScheduleGuideState(
    seed?: Partial<ChoirScheduleGuideState> | null
): ChoirScheduleGuideState {
    const completedSeed = seed?.completed;
    const completed = Array.isArray(completedSeed)
        ? completedSeed.filter((step): step is ChoirScheduleGuideStepId => CHOIR_SCHEDULE_GUIDE_STEPS.includes(step as ChoirScheduleGuideStepId))
        : [];

    return {
        completed,
        dismissed_at: seed?.dismissed_at ?? null,
        completed_at: seed?.completed_at ?? null,
    };
}

export function getChoirScheduleGuideNextStep(state: ChoirScheduleGuideState): ChoirScheduleGuideStepId | null {
    const completed = new Set(state.completed || []);
    return CHOIR_SCHEDULE_GUIDE_STEPS.find((step) => !completed.has(step)) || null;
}

export function isChoirScheduleGuideStepCompleted(
    state: ChoirScheduleGuideState,
    step: ChoirScheduleGuideStepId
): boolean {
    return state.completed.includes(step);
}

export function markChoirScheduleGuideStep(
    state: ChoirScheduleGuideState,
    step: ChoirScheduleGuideStepId
): ChoirScheduleGuideState {
    if (state.completed.includes(step)) {
        return state;
    }

    const nextCompleted = [...state.completed, step];
    const done = nextCompleted.length >= CHOIR_SCHEDULE_GUIDE_STEPS.length;

    return {
        ...state,
        completed: nextCompleted,
        completed_at: done ? state.completed_at || new Date().toISOString() : state.completed_at,
    };
}
